import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a6c8eb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex xl:tw-justify-between xl:tw-items-center tw-self-stretch tw-px-5 tw-py-3.5 tw-rounded-md noteInfo" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-2.5 tw-w-full main__wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/bulb_icon.svg",
  alt: "bulb",
  class: "tw-w-[18px] tw-h-[18px] icon",
  style: {}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _renderSlot(_ctx.$slots, "default", { class: "tw-text-[#211F58] tw-text-[15px]" }, undefined, true)
    ]),
    (_ctx.showCloseButton)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: "/img/close_icon.svg",
          alt: "close",
          class: "tw-w-[11.999px] tw-h-[12px] tw-cursor-pointer tw-z-[1]",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }))
      : _createCommentVNode("", true)
  ]))
}